import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BarChart3, Download, Users, HelpCircle, Gamepad2 } from 'lucide-react';

export const ReportsPage = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-accent-dark mb-2">التقارير والإحصائيات</h1>
        <p className="text-accent-dark/70">عرض وتحليل إحصائيات اللعبة</p>
      </div>

      {/* Report Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card className="border-2 border-accent-greenLight/20 hover:shadow-lg transition-all">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Users className="w-5 h-5 text-accent-greenDark" />
              تقرير المستخدمين
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-accent-dark/70 mb-4">
              إحصائيات شاملة عن المستخدمين والنشاط
            </p>
            <Button variant="outline" className="w-full border-accent-greenLight/30">
              <Download className="w-4 h-4 mr-2" />
              تصدير التقرير
            </Button>
          </CardContent>
        </Card>

        <Card className="border-2 border-accent-greenLight/20 hover:shadow-lg transition-all">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Gamepad2 className="w-5 h-5 text-secondary" />
              تقرير الألعاب
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-accent-dark/70 mb-4">
              إحصائيات الألعاب والأداء
            </p>
            <Button variant="outline" className="w-full border-accent-greenLight/30">
              <Download className="w-4 h-4 mr-2" />
              تصدير التقرير
            </Button>
          </CardContent>
        </Card>

        <Card className="border-2 border-accent-greenLight/20 hover:shadow-lg transition-all">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <HelpCircle className="w-5 h-5 text-accent-red" />
              تقرير الأسئلة
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-accent-dark/70 mb-4">
              تحليل أداء الأسئلة والصعوبة
            </p>
            <Button variant="outline" className="w-full border-accent-greenLight/30">
              <Download className="w-4 h-4 mr-2" />
              تصدير التقرير
            </Button>
          </CardContent>
        </Card>
      </div>

      {/* Coming Soon */}
      <Card className="border-2 border-accent-greenLight/20">
        <CardContent className="p-12 text-center">
          <BarChart3 className="w-16 h-16 mx-auto mb-4 text-accent-dark/30" />
          <p className="text-lg text-accent-dark/70 mb-2">التقارير قيد التطوير</p>
          <p className="text-sm text-accent-dark/50">
            سيتم إضافة التقارير التفصيلية والإحصائيات قريباً
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
